import React from 'react';

import {isKnownVariable} from '../../lib/json-logic-utils';

import Delete from './Delete';

const blankNumberPlaceholder = '__agyle_json_logic_builder_num__';

function Terminal({removable = true, ...props}) {
  let TerminalComponent;

  switch(typeof props.value) {
    case 'string':
      if (!!props.options && props.options.length > 0 && (props.value.length === 0 || isOptionSelected(props.options, props.value))) {
        TerminalComponent = OptionsComponent;
      }
      else if (props.value === blankNumberPlaceholder) {
        TerminalComponent = NumberTerminal;
      }
      else {
        TerminalComponent = StringTerminal;
      }
      break;
    case 'number':
      TerminalComponent = NumberTerminal;
      break;
    case 'boolean':
      TerminalComponent = BooleanTerminal;
      break;
    default:
      TerminalComponent = VariableTerminal;
  }

  return (
    <span>
      <TerminalComponent {...props} />
      {removable ? (
        <Delete onClick={() => props.onChange(null)} />
      ) : null}
    </span>
  );
}

function isOptionSelected(options, value) {
  return options.filter(option => option.value === value).length > 0;
}

function OptionsComponent({options, value, onChange}) {
  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}>
      <option value="">Select an option</option>
      {options.map(option => (
        <option key={option.value} value={option.value}>{option.name}</option>
      ))}
    </select>
  )
}

function VariableTerminal({variables, value, onChange}) {
  // A copied formula can point at a variable that is no longer on offer, e.g. the question was switched to
  // sheet setup, which drops every row question from the list. Without a placeholder the select falls back to
  // showing the first option while the formula still holds the old variable, so the question looks set up but
  // answers blank until the user re-picks. Show it as unselected instead, so picking commits a real value.
  const known = isKnownVariable(variables, value.var);

  return (
    <select
      value={known ? value.var : ''}
      onChange={e => onChange({'var': e.target.value})}
      style={{width: 150, textOverflow: 'ellipsis'}}>
      {known ? null : <option value="">Select a variable</option>}
      {Object.keys(variables).map(variable => (
        <option key={variable} value={variable}>{variables[variable].label}</option>
      ))}
    </select>
  );
}

function BooleanTerminal({value, onChange}) {
  return (
    <select value={value === null ? null : value.toString()} onChange={e => onChange(e.target.value === 'true')}>
      <option value="true">Yes (True)</option>
      <option value="false">No (False)</option>
    </select>
  );
}

function NumberTerminal({value, onChange}) {
  if(value === blankNumberPlaceholder) {
    value = '';
  }

  return (
    <input
      type="number"
      step="any"
      value={value}
      style={{width: 100}}
      onDoubleClick={e => e.stopPropagation()}
      onChange={e => {
        const nextValue = e.target.value;

        if(nextValue === '') {
          onChange(blankNumberPlaceholder);
        }
        else {
          onChange(parseFloat(e.target.value));
        }
      }}
    />
  );
}

function StringTerminal({value, onChange}) {
  return <input type="text" value={value} onChange={e => onChange(e.target.value)} />;
}

export default Terminal;
